import EventEmitter from './utils/EventEmitter';
import Swiper from 'swiper';

export default class MediaInterventionBloc extends EventEmitter {
  constructor(element) {
    super();

    this.el = element;

    this.paragraphParent = this.el.closest('.paragraph');

    this.list = this.el.querySelector('.media-intervention-items-list');
    this.items = this.el.querySelectorAll('.media-intervention-item');

    this.init();
  }

  init() {
    // Il nous faut systématiquement 4 items présent dans ce bloc donc si il y en a moins on va chercher des items en plus en AJAX pour compléter le bloc
    if (this.items.length < 4) {
      this.fetchView(this.el.dataset.viewName, this.el.dataset.viewDisplayId, this.el.dataset.viewArgs);
    } else {
      this.reorderByDate();
    }
  }

  fetchView(viewName, viewDisplayId, viewArgs = null) {
    const formData = new FormData();
    formData.append('view_name', viewName);
    formData.append('view_display_id', viewDisplayId);

    if (viewArgs !== null) {
      formData.append('view_args', viewArgs);
    }

    const fetchOptions = {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // Pour indiquer une requête AJAX
      },
    };

    const ajaxUrl = Drupal.url('views/ajax');

    fetch(ajaxUrl, fetchOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data[3] !== undefined) {
          const viewHtml = data[3].data;

          // on va chercher les items dans le html de la vue, on veut récupérer les class media-intervention-item-inner
          const parser = new DOMParser();
          const doc = parser.parseFromString(viewHtml, 'text/html');
          const items = doc.querySelectorAll('.media-intervention-item-inner');

          // si on trouve pas d'items on arrête
          if (items.length === 0 && this.items.length === 0) {
            // remove the bloc
            this.paragraphParent.remove();
            return;
          }

          // On complète la liste pour arriver à 4 items, si on avait déjà 2 items et qu'on en ajoute 2 on aura donc 4 items
          for (let i = 0; i < 4 - this.items.length; i++) {
            const div = document.createElement('div');
            div.classList.add('media-intervention-item');
            div.innerHTML = items[i].outerHTML;
            this.list.appendChild(div);
          }

          Drupal.settings = data[0].settings;
          Drupal.settings.dialog = {
            'autoResize': true,
            'maxHeight': '95%',
            'autoOpen': true,
            'dialogClass': '',
            'buttonClass': 'button',
            'buttonPrimaryClass': 'button--primary',
          };
          drupalSettings.views = data[0].settings.views;
          Drupal.attachBehaviors(this.activeTabContent, Drupal.settings);

          this.reorderByDate();

        }
      })
      .catch((error) => {
        console.error('Fetch error:', error);
      });
  }

  reorderByDate() {
    // On va chercher tous les items et les trier par date
    const items = this.el.querySelectorAll('.media-intervention-item');
    const itemsArray = Array.from(items);
    itemsArray.sort((a, b) => {
      if (a.querySelector('.date') === null ) {
        return 1;
      }
      if (b.querySelector('.date') === null ) {
        return -1;
      }
      const aDate = new Date(a.querySelector('.date').innerHTML);
      const bDate = new Date(b.querySelector('.date').innerHTML);
      return bDate - aDate;
    });

    // On vide la liste
    this.list.innerHTML = '';

    if (window.innerWidth > 768) {
      // On réinjecte les items triés
      itemsArray.forEach((item) => {
        if (itemsArray.indexOf(item) === 0) {
          item.classList.remove('media-intervention-item--mini');
          item.classList.add('w100');
        } else {
          item.classList.remove('w100');
          item.classList.add('media-intervention-item--mini');
        }
        this.list.appendChild(item);
        this.trigger('itemsReordered');
      });
    } else {
      // On prépare le slider
      const slider = document.createElement('div');
      slider.classList.add('media-intervention-slider');
      // On fait le swiper-wrapper
      const swiperWrapper = document.createElement('div');
      swiperWrapper.classList.add('swiper-wrapper');

      // On réinjecte les items triés
      itemsArray.forEach((item) => {
        // Si c'est le premier on l'affiche en grand
        if (itemsArray.indexOf(item) === 0) {
          item.classList.remove('media-intervention-item--mini');
          item.classList.add('w100');
          this.list.appendChild(item);
        } else {
          // Pour les autres on veut les afficher dans le slider
          item.classList.remove('w100');
          item.classList.add('media-intervention-item--mini');
          // On wrappe l'item dans un swiper-slide
          const swiperSlide = document.createElement('div');
          swiperSlide.classList.add('swiper-slide');
          swiperSlide.appendChild(item);
          swiperWrapper.appendChild(swiperSlide);
        }

        // Si on a fini de boucler on ajoute le slider
        if (itemsArray.indexOf(item) === itemsArray.length - 1) {
          slider.appendChild(swiperWrapper);
          this.list.appendChild(slider);
          // On initialise le slider

          const swiper = new Swiper('.media-intervention-slider', {
            slidesPerView: '1.25',
            spaceBetween: 30,
            speed: 750,
            centeredSlides: false,
            loop: false,
          });
        }
      });

      this.trigger('itemsReordered');
    }
  }
}
